import axios from "axios";
import { useAuthContext as useAuth } from "../context/authContext";
import config from "../config";
import { useLangContext } from "../context/langContext";

const useProtectedAxiosInstance = () => {
  const { token } = useAuth();
  const { lang } = useLangContext();

  return axios.create({
    baseURL: config.API_URL,
    timeout: Number(config.REQUEST_TIMEOUT_MILLISECONDS),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "Accept-Language": lang,
    },
  });
};

const useFormDataAxiosInstance = () => {
  const { token } = useAuth();
  const { lang } = useLangContext();

  return axios.create({
    baseURL: config.API_URL,
    timeout: Number(config.REQUEST_TIMEOUT_MILLISECONDS),
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
      "Accept-Language": lang,
    },
  });
};

const usePublicAxiosInstance = () => {
  const { lang } = useLangContext();
  return axios.create({
    baseURL: config.API_URL,
    timeout: Number(config.REQUEST_TIMEOUT_MILLISECONDS),
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": lang,
    },
  });
};

export {
  useProtectedAxiosInstance,
  usePublicAxiosInstance,
  useFormDataAxiosInstance,
};
